import styled from 'styled-components';

import Modal from 'components/shared/Modal';

export const CustomModal = styled(Modal)`
  ._modalContainer {
    max-width: 600px;
    max-height: 510px;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 52px 23px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: #821c0e;
  margin-bottom: 10px;

  > h3 {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    font-size: 24px;
    margin-left: 23px;
  }

  svg {
    color: #821c0e;
  }
`;

export const CommentsListWrapper = styled.div<{ readOnly?: boolean }>`
  height: ${({ readOnly }) => (readOnly ? '350px' : '250px')};
  width: 100%;

  > p {
    font-family: ${({ theme }) => theme.font.fontFamily.bold};
    color: #821c0e;
    font-size: 0.9em;
  }
`;

export const CommentWrapper = styled.div`
  height: 100px;
  width: 100%;
  margin-top: 1rem;
`;
